// extracted by mini-css-extract-plugin
export default {"payroll-sum-emp-header":"PayrollSummEmpReport_payroll-sum-emp-header__1Xz+g","divider":"PayrollSummEmpReport_divider__NqJvg"};